module.exports = __webpack_public_path__ + "img/40327775.763fc97f.png";